import { render, staticRenderFns } from "./ServiceGroups.vue?vue&type=template&id=1e3e6132&scoped=true&"
import script from "./ServiceGroups.vue?vue&type=script&lang=js&"
export * from "./ServiceGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e6132",
  null
  
)

export default component.exports